import { Percentage } from '@sparkdotfi/common-universal'

import { POINTS_SEASON3_ACTIVE } from '@/config/chain/flags'

export const referralBoostPercentage = Percentage(0.1)
export const pointsSeason1StartMonth = 'May'
export const pointsSeason1EndMonth = 'Aug'
export const pointsSeason2StartMonth = 'Aug'
export const pointsSeason2EndMonth = 'Dec'
export const pointsSeason3StartMonth = 'Dec'
export const pointsSeason3EndMonth = 'Apr'

export const referralCodeLength = 6

export const sparkPointsOnboardingDialogId = 'spark-points-onboarding-dialog'

export const season3Active = POINTS_SEASON3_ACTIVE

export const benmoInviteCode = 'BWNFAK'
